module.exports = __webpack_public_path__ + "img/shield_done.ff3ae18e.svg";